import { render, staticRenderFns } from "./IftttEdit.vue?vue&type=template&id=0284e480&scoped=true"
import script from "./IftttEdit.vue?vue&type=script&lang=js"
export * from "./IftttEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0284e480",
  null
  
)

export default component.exports